import { throttle } from 'lodash';
export async function requestContentCardsRefresh() {
  const {
    requestContentCardsRefresh: brazeRequestContentCardsRefresh
  } = await import('@braze/web-sdk');
  return new Promise((resolve, reject) => {
    brazeRequestContentCardsRefresh(resolve, reject);
  });
}
const CONTENT_CARDS_REFRESH_THROTTLE_INTERVAL = 10000;
export const requestContentCardsRefreshThrottled = throttle(requestContentCardsRefresh, CONTENT_CARDS_REFRESH_THROTTLE_INTERVAL, {
  leading: true,
  trailing: false
});
export async function disableBraze() {
  const {
    disableSDK
  } = await import('@braze/web-sdk');
  disableSDK();
}
export async function enableBraze() {
  const {
    enableSDK
  } = await import('@braze/web-sdk');
  enableSDK();
}
export async function flushBraze() {
  const {
    requestImmediateDataFlush
  } = await import('@braze/web-sdk');
  return new Promise(resolve => {
    requestImmediateDataFlush(resolve);
  });
}
export async function getBrazeUserId() {
  const {
    getUser
  } = await import('@braze/web-sdk');
  const brazeUser = getUser();
  if (!brazeUser) return null;
  return new Promise(resolve => {
    brazeUser.getUserId(resolve);
  });
}